<template>
    <Modal v-model="dialog">
        <template v-slot:header>
            <h3 style="margin-bottom: 0px">{{ $t('common.generalities.occupants') }}</h3>
        </template>
        <template v-slot:content>
            <div class="row">
                    <div class="col-12 col-md-6">
                        <Stepper
                            :title="$t('common.reservation.numberOfAdults')"
                            v-model="numberOfAdults"
                            :minValue="0"/>
                    </div>
                
                
                    <div class="col-12 col-md-6">
                        <Stepper
                            :title="$t('common.reservation.numberOfKids')"
                            v-model="numberOfKids"
                            :minValue="0"/>
                    </div>
                </div>
        </template>
    </Modal>
</template>

<script>
import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';
import Stepper from "@/components/common/Stepper"
import Modal from "@/components/common/Modal";

export default {
    name: "OccupantsPicker",
    components: {
        Popper,
        Stepper,
        Modal
    },
    props: {
        value: {
            type: Boolean,
            required: false,
            default: false
        },
        adults: {
            type: Number,
            required: true,
            default: 0
        },
        kids: {
            type: Number,
            required: true,
            default: 0
        }
    },
    computed: {
        numberOfAdults: {
            get() {
                return this.adults;
            },
            set(val) {
                this.$emit('update:adults', val)
            }
        },
        numberOfKids: {
            get() {
                return this.kids;
            },
            set(val) {
                this.$emit('update:kids', val)
            }
        },
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    methods: {
        closePopup: function() {
            this.$refs['popper'].doClose();
        }
    }
}
</script>

<style lang="scss" scoped>
    $border-radius: 5px;

    .popper {
        background-color: white;
        text-align: left;
    }
    .vc-border {
        border-width: 0;
    }


    .btn {
        border-radius: $border-radius;
    }

    .btn-outline-primary {
        background-color: transparent !important;
        border-color: $primary-color !important;
        color: $primary-color !important;
        
    }
    .btn-outline-primary.active.show {
        background-color: $primary-color !important;
        color: white !important;
    }

</style>